const initialState = {
  post: {},
  posts: [],
  postCount: 0,
  postCurrent: 1
};

const post = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_POSTS':
      return {
        ...state,
        posts: action.posts,
        postCount: action.postCount,
        postCurrent: action.postCurrent
      };
    case 'GET_POST_DETAIL':
      return {
        ...state,
        post: action.post
      };

    case 'DELETE_POST':
      return {
        ...state,
        posts: state.posts.filter((p) => p.id !== action.postId)
      };

    case 'RESET_POST_STATE':
      return {
        ...initialState
      };

    default:
      return { ...state };
  }
};

export default post;
